import React, { useState } from 'react'
import DatePicker, { registerLocale } from 'react-datepicker'
import * as locales from 'date-fns/locale'

import 'react-datepicker/dist/react-datepicker.css'

type Props = {
	inputTarget: HTMLElement
	locale: string
}

const Datetime = ({ inputTarget, locale }: Props) => {
	const [startDate, setStartDate] = useState(null)

	// @ts-ignore
	registerLocale(locale, locales[locale])

	const changeHandler = (date: any) => {
		const finalTarget = inputTarget as HTMLInputElement

		setStartDate(date)

		finalTarget.value = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
	}

	return <DatePicker locale={locale} selected={startDate} placeholderText={'mm/dd/yyyy'} onChange={changeHandler} />
}

export default Datetime
